import { observer } from 'mobx-react';

import { useQuestWidgetData } from '../../hooks/useQuestWidgetData';
import type { QuestWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { QuestWidgetTimer } from './QuestWidgetTimer/QuestWidgetTimer';

interface QuestWidgetProps {
  sizeType: WidgetSizeType;
  data: QuestWidgetDataType;
}

function QuestWidgetComponent(props: QuestWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;

  const { widgetImageUrl, handleClick, onTimerEnd } = useQuestWidgetData({ event });

  const hideTimer = event.hideTimer || !event.expiredAt;

  const timer = hideTimer ? null : (
    <QuestWidgetTimer endDate={event.expiredAt} extended={sizeType === 'wide'} onEnd={onTimerEnd} />
  );
  const smallWidgetExtended = !!timer;

  return (
    <WidgetWrapper
      dataTestId={data.dataTestId}
      sizeType={sizeType}
      smallWidgetExtended={smallWidgetExtended}
      onClick={handleClick}
    >
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const QuestWidget = observer(QuestWidgetComponent);
